import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { useRouteMatch } from 'react-router-dom'
import { ISelectorOption, useStores } from '@trivie/core'
import { Dialog } from '@trivie/ui-web/components/dialogs/dialog'
import { AutocompleteSelector } from '../../../components/autocomplete-selector'
// eslint-disable-next-line
const _array = require('lodash/array')

export const AddToTopicsDialog = observer((props: any) => {
  const { open, onClose } = props
  const { manageResourceStore } = useStores()
  const { params } = useRouteMatch()
  const { getRelatedTopics, relatedTopics, addResourceToTopics } = manageResourceStore
  const [selectedOptions, setSelectedOptions] = useState<ISelectorOption[]>([])
  //@ts-ignore
  const { id } = params

  const handleSubmit = () => {
    const newSelects = _array.differenceWith(
      selectedOptions,
      relatedTopics,
      (x: ISelectorOption, y: any) => x.id === y.topic_id,
    ) as { id: number }[]

    const topic_ids = newSelects.map((val) => val.id)

    addResourceToTopics(id, topic_ids).then(() => {
      getRelatedTopics(id)
      setSelectedOptions([])
      onClose()
    })
  }

  const handleSelectionChange = (selected: ISelectorOption[]) => {
    setSelectedOptions(selected)
  }

  return (
    <Dialog
      onCancel={onClose}
      onConfirm={handleSubmit}
      confirmBtnLabel="Add Source"
      disableConfirm={selectedOptions.length === 0}
      onClose={onClose}
      title="Add Source to Topic"
      open={open}
      sx={{
        '& .MuiDialogContent-root': {
          display: 'flex',
          flex: 1,
          overflow: 'hidden',
          maxHeight: 500,
          flexDirection: 'column',
        },
      }}
      maxWidth="sm"
    >
      <div
        style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          overflowY: 'hidden',
          height: 500,
        }}
      >
        <AutocompleteSelector
          variant="topics"
          open
          noOptionsText="No matching topics."
          onSelectionChange={handleSelectionChange}
        />
      </div>
    </Dialog>
  )
})
